import { useState } from 'react'
import { LuX } from 'react-icons/lu'
import { useComparison } from '../context/ComparisonContext.jsx'
import { usePropertyData } from '../hooks/usePropertyData.js'
import ComparisonModal from './ComparisonModal.jsx'

const ComparisonTray = () => {
  const { comparisonIds, removeFromComparison, clearComparison } = useComparison()
  const { properties } = usePropertyData()
  const [modalOpen, setModalOpen] = useState(false)

  const selectedProperties = comparisonIds
    .map((id) => properties.find((p) => p.id === id))
    .filter(Boolean)

  const isVisible = selectedProperties.length >= 1

  return (
    <>
      <div className={`comparison-tray${isVisible ? ' is-visible' : ''}`} role="region" aria-label="Property comparison tray">
        <div className="comparison-tray__inner">
          <div className="comparison-tray__slots">
            {selectedProperties.map((property) => (
              <div key={property.id} className="comparison-tray__slot">
                <img
                  src={property.heroImage}
                  alt={property.title}
                  className="comparison-tray__thumb"
                />
                <div className="comparison-tray__slot-info">
                  <span className="comparison-tray__slot-title">{property.title}</span>
                  <span className="comparison-tray__slot-price">
                    £{Number(property.price).toLocaleString('en-GB')}
                  </span>
                </div>
                <button
                  type="button"
                  className="comparison-tray__remove"
                  aria-label={`Remove ${property.title} from comparison`}
                  onClick={() => removeFromComparison(property.id)}
                >
                  <LuX aria-hidden="true" />
                </button>
              </div>
            ))}
            {Array.from({ length: 3 - selectedProperties.length }).map((_, i) => (
              <div key={`empty-${i}`} className="comparison-tray__slot comparison-tray__slot--empty">
                <span>Add property</span>
              </div>
            ))}
          </div>

          <div className="comparison-tray__actions">
            <button
              type="button"
              className="comparison-tray__compare-btn"
              disabled={selectedProperties.length < 2}
              onClick={() => setModalOpen(true)}
            >
              Compare {selectedProperties.length >= 2 ? `${selectedProperties.length} properties` : '(select 2+)'}
            </button>
            <button
              type="button"
              className="comparison-tray__clear-btn"
              onClick={clearComparison}
            >
              Clear all
            </button>
          </div>
        </div>
      </div>

      {modalOpen && (
        <ComparisonModal
          properties={selectedProperties}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  )
}

export default ComparisonTray
